var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-section",class:_vm.theme},[_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"},[_vm._v(_vm._s(_vm.trans('misc.loading'))+" ...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }